import { Pipe, PipeTransform } from '@angular/core';
import { ARTIST_ROLE_ID, COMPOSER_ROLE_ID, Person } from '@shared/interfaces';

@Pipe({
  name: 'personRoute'
})
export class PersonRoutePipe implements PipeTransform {

  transform(person: Person): string[] {
    if (!person?.roles?.length && !person?.rolesId?.length) {
      return undefined;
    }

    const ids = person?.rolesId || person?.roles.map(e => e.id) || person?.rolesId;

    if (ids.includes(COMPOSER_ROLE_ID)) {
      return ['/composers', `${ person.id }`];
    }

    if (ids.includes(ARTIST_ROLE_ID)) {
      return ['/performers', `${ person.id }`];
    }

    return undefined;
  }
}
